import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  SupplierName,
  SupplierGroup,
  SupplierType,
  Territory,
  IsTransporter,
  BillingCurrency,
  DefaultCompanyBankAccount,
  DefaultPriceList,
  IsInternalSupplier,
  RepresentsCompany,
  Website,
  SupplierDetails,
}) => {
  return (
      <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
                    id="SupplierName"
                    style={{
                      height: "30px",
                      border: SupplierName.Error ? "1px solid red" : "",
                    }}
                    label="Supplier Name"
                    value={SupplierName.value}
                    onChange={(e) => SupplierName.setValue(e.target.value)}
                  />

                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={SupplierGroup.SupplierGroup_list}

                    label="Supplier Group"
                    getOptionLabel={(item) =>
                      item.isNew ? "+ Create New Supplier Group" : item.name
                    }
                    getOptionValue={(item) => item.name}
                    createNewUrl="/master/suppliergroup/create-supplier"
                    createNewLabel="Create New Supplier Group"
                    value={SupplierGroup.value}
                    onChange={(val) => SupplierGroup.setValue(val)}
                  />



                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={[{ name: "Company" }, { name: "Individual" }, { name: "Partnership" }]}

                    label="Supplier Type"
                    getOptionLabel={(item) => item.name}
                    getOptionValue={(item) => item.name}
                    value={SupplierType?.value || ""}
                    onChange={(value) => SupplierType?.setValue?.(value)}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={Territory.Territory_list}
                    style={{
                      height: "30px",
                    }}
                    label="Territory"
                    getOptionLabel={(item) => item.name} // 👈 Required
                    getOptionValue={(item) => item.name} // 👈 Required
                    value={Territory.value}
                    onChange={(val) => Territory.setValue(val)}
                  />
                </div>


                <div style={{ flex: 1 }}>
                  <Input
                    id="Website"
                    style={{
                      height: "30px",
                      border: Website.Error ? "1px solid red" : "",
                    }}
                    label="Website"
                    value={Website.value}
                    onChange={(e) => Website.setValue(e.target.value)}
                  />

                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="IsTransporter"
                    label="Is Transporter"
                    value={IsTransporter?.value || false}
                    onChange={(val) => IsTransporter?.setValue?.(val)}
                  />
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Defaults</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>


                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={BillingCurrency.BillingCurrency_list}
                    style={{
                      height: "30px",
                      border: BillingCurrency.Error ? "1px solid red" : "",
                    }}
                    label="Billing Currency"
                    getOptionLabel={(item) => item.name} // 👈 Required
                    getOptionValue={(item) => item.name} // 👈 Required
                    value={BillingCurrency.value}
                    onChange={(val) => BillingCurrency.setValue(val)}
                  />

                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={DefaultCompanyBankAccount.DefaultCompanyBankAccount_list}
                    style={{
                      height: "30px",
                      border: DefaultCompanyBankAccount.Error ? "1px solid red" : "",
                    }}
                    label="Default Company Bank Account"
                    getOptionLabel={(item) => item.name} // 👈 Required
                    getOptionValue={(item) => item.name} // 👈 Required
                    value={DefaultCompanyBankAccount.value}
                    onChange={(val) =>
                      DefaultCompanyBankAccount.setValue(
                        val
                      )
                    }
                  />



                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={DefaultPriceList.DefaultPriceList_list}
                    style={{
                      height: "30px",
                      border: DefaultPriceList.Error ? "1px solid red" : "",
                    }}
                    label="Default Price List"
                    getOptionLabel={(item) => item.name} // 👈 Required
                    getOptionValue={(item) => item.name} // 👈 Required
                    value={DefaultPriceList.value}
                    onChange={(val) =>
                      DefaultPriceList.setValue(val)
                    }
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>



                <div style={{ flex: 1 }}>

                  <Input
                    id="SupplierDetails"
                    style={{
                      height: "30px",
                      border: SupplierDetails?.Error ? "1px solid red" : "",
                    }}
                    label="Supplier Details"
                    value={SupplierDetails.value}
                    onChange={(e) =>
                      SupplierDetails.setValue(e.target.value)
                    }
                  />
                  <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      lineHeight: '2',
                      fontFamily: "Roboto, sans-serif",
                      marginTop: '-8px'
                    }}
                  >
                    Statutory info and other general information about your Supplier
                  </p>


                </div>



              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  {/* <label style={{ height: '2px' }}></label> */}
                  <Checkbox
                    id="IsInternalSupplier"
                    label="Is Internal Supplier"
                    value={IsInternalSupplier.value || false}
                    onChange={(val) =>
                      IsInternalSupplier?.setValue?.(val)
                    }
                   
                    
                  />
                </div>
                 {IsInternalSupplier?.value ? (
                <div style={{ flex: 1 }}>
                 
                    <SelectSearch
                      list={RepresentsCompany.RepresentsCompany_list}
                      style={{
                        height: "30px",
                        border: RepresentsCompany.Error ? "1px solid red" : "",
                      }}
                      label="Represents Company"
                      getOptionLabel={(item) =>
                        item.isNew ? "+ Create New Company" : item.name
                      }
                      getOptionValue={(item) => item.name}
                      createNewUrl="/master/company/create-Company"
                      createNewLabel="Create New Company"
                      value={RepresentsCompany.value}
                      onChange={(val) => RepresentsCompany.setValue(val)}
                    />
                  
                </div>
                ):null}
                <div style={{ flex: 1 }}></div>
              </div>

            </div>
          </div>
        </div>
         
         <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Supplier" docname={IdData} />
            </div>
          </div>
        </div>
         
      </div>

    </div>
  );
};

export default Tab1;
